'use client';
import Icon from '../Icon';
import { events, buildCalCells } from '@/lib/vster/data';

interface Props {
  navigate: (s: string) => void;
  evView: 'calendar' | 'card';
  setEvView: (v: 'calendar' | 'card') => void;
}

const FILTERS = ['전체', 'IR·투자', '교육', '박람회', '설명회', '공모전', '입주모집'];

export default function EventsScreen({ navigate, evView, setEvView }: Props) {
  const calCells = buildCalCells();

  return (
    <main style={{ maxWidth: 1280, margin: '0 auto', padding: '28px 24px 80px', animation: 'vfade .4s ease' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 16, flexWrap: 'wrap', marginBottom: 8 }}>
        <div>
          <h1 className="vh2" style={{ fontSize: 32, fontWeight: 700, letterSpacing: '-.015em', margin: '0 0 4px' }}>행사·이벤트</h1>
          <p style={{ fontSize: 16, color: '#434654', margin: 0 }}>데모데이·박람회·교육·설명회·입주 모집을 한 곳에서.</p>
        </div>
        <div style={{ display: 'flex', gap: 6, background: '#e9edff', padding: 4, borderRadius: 11 }}>
          {(['calendar', 'card'] as const).map(v => (
            <button key={v} onClick={() => setEvView(v)} style={{ border: 'none', cursor: 'pointer', padding: '8px 16px', borderRadius: 8, fontSize: 14, fontWeight: 600, background: evView === v ? '#fff' : 'transparent', color: evView === v ? '#003d9b' : '#434654', boxShadow: evView === v ? '0 1px 4px rgba(5,26,62,.08)' : 'none' }}>
              {v === 'calendar' ? '캘린더형' : '카드형'}
            </button>
          ))}
        </div>
      </div>

      {/* 필터 태그 */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '18px 0 24px' }}>
        {FILTERS.map((f, i) => (
          <span key={f} style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 13, padding: '8px 14px', borderRadius: 999, background: i === 0 ? '#003d9b' : '#fff', color: i === 0 ? '#fff' : '#434654', border: i === 0 ? 'none' : '1px solid #d8e2ff', cursor: 'pointer' }}>{f}</span>
        ))}
      </div>

      {/* 캘린더형 */}
      {evView === 'calendar' && (
        <div className="vstack-sm" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.35fr) minmax(320px,1fr)', gap: 24, alignItems: 'start' }}>
          <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 16, padding: 22, boxShadow: '0 2px 12px rgba(5,26,62,.03)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
              <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>2026년 7월</h2>
              <div style={{ display: 'flex', gap: 6 }}>
                {['chevron_left', 'chevron_right'].map(icon => (
                  <span key={icon} style={{ width: 34, height: 34, border: '1px solid #e4e8f6', borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#434654', cursor: 'pointer' }}>
                    <Icon name={icon} size={20} />
                  </span>
                ))}
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 4, marginBottom: 6 }}>
              {['일', '월', '화', '수', '목', '금', '토'].map((d, i) => (
                <span key={d} style={{ textAlign: 'center', fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, color: i === 0 ? '#ba1a1a' : i === 6 ? '#003d9b' : '#434654', padding: '6px 0' }}>{d}</span>
              ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 4 }}>
              {calCells.map((c, i) => (
                <div key={i} style={{ aspectRatio: '1', borderRadius: 9, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, background: c.cellBg, border: c.cellBorder }}>
                  <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 13, color: c.numColor }}>{c.day}</span>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: c.dot, display: 'inline-block' }} />
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 16, borderTop: '1px solid #eef1fb', paddingTop: 14 }}>
              {[{ color: '#003d9b', label: 'IR·투자' }, { color: '#eab308', label: '박람회' }, { color: '#4633a0', label: '공모전' }, { color: '#93000a', label: '입주모집' }].map(l => (
                <span key={l.label} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#434654' }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: l.color, display: 'inline-block' }} />{l.label}
                </span>
              ))}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>다가오는 행사</h2>
            {events.map((e, i) => (
              <div key={i} style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 14, padding: 16, display: 'flex', flexDirection: 'column', gap: 9, boxShadow: '0 2px 12px rgba(5,26,62,.03)', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 4, background: e.typeColor }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: 6 }}>
                  <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, padding: '4px 10px', borderRadius: 999, background: e.typeBg, color: e.typeColor }}>{e.type}</span>
                  <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, color: '#00687b' }}>{e.dday}</span>
                </div>
                <h3 style={{ fontSize: 16, fontWeight: 600, lineHeight: 1.35, margin: 0, paddingLeft: 6 }}>{e.title}</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, paddingLeft: 6 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#434654', fontSize: 13 }}><Icon name="calendar_today" size={16} color="#737685" />{e.date}</span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#434654', fontSize: 13 }}><Icon name="location_on" size={16} color="#737685" />{e.loc} · {e.org}</span>
                </div>
                <div style={{ display: 'flex', gap: 8, paddingLeft: 6, marginTop: 2 }}>
                  <button style={{ flex: 1, background: '#003d9b', color: '#fff', border: 'none', cursor: 'pointer', padding: 9, borderRadius: 9, fontSize: 13, fontWeight: 600 }}>참가 신청</button>
                  <button onClick={() => navigate('kanban')} style={{ background: '#e9edff', color: '#003d9b', border: 'none', cursor: 'pointer', padding: '9px 12px', borderRadius: 9, fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Icon name="add_task" size={16} />트래킹
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 카드형 */}
      {evView === 'card' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(300px,1fr))', gap: 18 }}>
          {events.map((e, i) => (
            <div key={i} style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 16, padding: 20, display: 'flex', flexDirection: 'column', gap: 12, boxShadow: '0 2px 12px rgba(5,26,62,.03)', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', left: 0, top: 0, right: 0, height: 4, background: e.typeColor }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
                <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, padding: '4px 10px', borderRadius: 999, background: e.typeBg, color: e.typeColor }}>{e.type}</span>
                <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, color: '#00687b' }}>{e.dday}</span>
              </div>
              <h3 style={{ fontSize: 17, fontWeight: 600, lineHeight: 1.35, margin: 0 }}>{e.title}</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#434654', fontSize: 13 }}><Icon name="calendar_today" size={16} color="#737685" />{e.date}</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#434654', fontSize: 13 }}><Icon name="location_on" size={16} color="#737685" />{e.loc}</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#434654', fontSize: 13 }}><Icon name="apartment" size={16} color="#737685" />{e.org}</span>
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 'auto', paddingTop: 4 }}>
                <button style={{ flex: 1, background: '#003d9b', color: '#fff', border: 'none', cursor: 'pointer', padding: 10, borderRadius: 9, fontSize: 13, fontWeight: 600 }}>참가 신청</button>
                <button onClick={() => navigate('kanban')} style={{ background: '#e9edff', color: '#003d9b', border: 'none', cursor: 'pointer', padding: '10px 12px', borderRadius: 9, fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>
                  <Icon name="add_task" size={16} />트래킹
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
